




































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { namespace, State, Action } from 'vuex-class'
const billDetail = namespace('billDetail')
@Component
export default class index extends Vue {
  @billDetail.State installPageLoading
  @Prop() detailData
  @Prop() pageType // orderInstall-订单详情  billInstall 账单详情
  @Prop() praData?: any // 1.用来判断是否逾期    01-未出账,02-正常，03-逾期，04-已结清;2 传值-借据编号
  flag: any = ''
  note: any = ''
  // 逾期判断  深蓝色逾期，灰色 结清04   其余浅色
  @Watch('detailData', { immediate: true })
  onChanged(val) {
    if (val.debtList) {
      val.debtList.map(item => {
        if (item.accStat == '03') {
          item['colorFlag'] = 'deepBlue'
        } else if (item.accStat == '04') {
          item['colorFlag'] = 'grayColor'
        } else {
          item['colorFlag'] = 'lightBlue'
        }
      })
    }
    // if (val.note) {
    //   if (val.note.indexOf('/') != -1) {
    //   }
    //   this.note = val.note.split(' ')[1]
    //   this.flag = val.note.split(' ')[0]
    // }
  }

  detailClick() {
    // order--订单详情  orderInstall--分期订单详情   billInstall--账单
    if (this.pageType == 'orderInstall') {
      this.$router.push({
        path: '/orderDetail',
        query: {
          pageFlag: 'orderInstall',
          debtNo: this.praData.debtNo,
          loanAcno: this.$route.query.loanAcno
        }
      })
    } else if (this.pageType == 'billInstall') {
      this.$router.push({
        path: '/billInstallDetail',
        query: { debtNo: this.praData.debtNo, loanAcno: this.$route.query.loanAcno }
      })
    } else {
      this.$router.push({ path: '/orderDetail', query: { pageFlag: 'order' } })
    }
  }
}
